const getters = {
  roles: (state) => state.userVUEX.roles,
  checkLoginStatus: (state) => state.userVUEX.loggedin,
};

export default getters;
